(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["elvyneco-announcement-countdown"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const ROOT_SELECTOR = '[data-elvyne-announcement]';
    const TIMER_SELECTOR = '[data-elvyne-timer]';
    const STORAGE_PREFIX = 'elvyne-countdown-v2:';
    const RUNTIME_STATE = new Map();

    class ElvyneTimer {
      constructor(element) {
        this.el = element;
        this.timeoutId = null;
        this.destroyed = false;
        this.lastCycleIndex = null;
        this.boundaryUntil = 0;
        this.mode = element.dataset.mode || 'static';
        this.persist = element.dataset.persist === 'true';
        this.leadingZeros = element.dataset.leadingZeros === 'true';
        this.visibleUnits = ['days', 'hours', 'minutes', 'seconds'].filter((unit) => element.dataset[`show${unit.charAt(0).toUpperCase()}${unit.slice(1)}`] === 'true');
        this.durationMs = this.getDurationMs();
        this.storageKey = `${STORAGE_PREFIX}${element.dataset.key || ''}`;
        this.signature = [this.mode, this.durationMs, element.dataset.fixed || '', element.dataset.autoRenew, element.dataset.restartZero].join('|');
        this.anchor = null;
        this.deadline = null;
      }

      getDurationMs() {
        const values = [
          Number(this.el.dataset.durationDays || 0),
          Number(this.el.dataset.durationHours || 0),
          Number(this.el.dataset.durationMinutes || 0),
          Number(this.el.dataset.durationSeconds || 0)
        ].map((value) => Number.isFinite(value) ? Math.max(0, value) : 0);
        const [days, hours, minutes, seconds] = values;
        return (((days * 24 + hours) * 60 + minutes) * 60 + seconds) * 1000;
      }

      shouldRepeat() {
        const autoRenew = this.el.dataset.autoRenew === 'true';
        const restart = this.el.dataset.restartZero === 'true';
        const recurringMode = this.mode === 'recurring' || (this.mode === 'duration' && autoRenew);
        return recurringMode && autoRenew && restart && this.durationMs > 0;
      }

      canUseStorage() {
        try {
          const probe = `${this.storageKey}:probe`;
          localStorage.setItem(probe, '1');
          localStorage.removeItem(probe);
          return true;
        } catch (_) {
          return false;
        }
      }

      clearPersistentState() {
        if (!this.canUseStorage()) return;
        try {
          localStorage.removeItem(this.storageKey);
        } catch (_) {}
      }

      readState() {
        const runtime = RUNTIME_STATE.get(this.storageKey);
        if (runtime && runtime.signature === this.signature) return runtime;

        if (!this.persist || !this.canUseStorage()) return null;
        try {
          const raw = localStorage.getItem(this.storageKey);
          if (!raw) return null;
          const parsed = JSON.parse(raw);
          if (!parsed || parsed.signature !== this.signature) {
            localStorage.removeItem(this.storageKey);
            return null;
          }
          RUNTIME_STATE.set(this.storageKey, parsed);
          return parsed;
        } catch (_) {
          return null;
        }
      }

      writeState(state) {
        const payload = { ...state, signature: this.signature };
        RUNTIME_STATE.set(this.storageKey, payload);
        if (!this.persist || !this.canUseStorage()) return;
        try {
          localStorage.setItem(this.storageKey, JSON.stringify(payload));
        } catch (_) {}
      }

      init() {
        this.destroy();
        this.destroyed = false;
        this.lastCycleIndex = null;
        this.boundaryUntil = 0;
        if (this.mode === 'static') return;

        if (!this.persist) this.clearPersistentState();

        const now = Date.now();
        const state = this.readState();

        if (this.mode === 'fixed') {
          const parsed = Date.parse(this.el.dataset.fixed || '');
          this.deadline = Number.isFinite(parsed) ? parsed : now;
        } else if (this.shouldRepeat()) {
          this.anchor = state && Number.isFinite(state.anchor) ? state.anchor : now;
          this.writeState({ anchor: this.anchor });
        } else {
          this.deadline = state && Number.isFinite(state.deadline) ? state.deadline : now + this.durationMs;
          this.writeState({ deadline: this.deadline });
        }

        this.tick();
      }

      destroy() {
        this.destroyed = true;
        if (this.timeoutId !== null) {
          clearTimeout(this.timeoutId);
          this.timeoutId = null;
        }
      }

      getRemaining(now) {
        if (this.mode === 'fixed') return Math.max(0, this.deadline - now);

        if (this.shouldRepeat()) {
          const elapsed = Math.max(0, now - this.anchor);
          const cycleIndex = Math.floor(elapsed / this.durationMs);
          const cycleElapsed = elapsed - cycleIndex * this.durationMs;

          if (this.lastCycleIndex !== null && cycleIndex > this.lastCycleIndex && cycleElapsed < 350) {
            this.boundaryUntil = now + (350 - cycleElapsed);
          }
          this.lastCycleIndex = cycleIndex;

          if (now < this.boundaryUntil) return 0;
          return Math.max(0, this.durationMs - cycleElapsed);
        }

        return Math.max(0, this.deadline - now);
      }

      splitUnits(ms) {
        let total = Math.max(0, Math.ceil(ms / 1000));
        const divisors = { days: 86400, hours: 3600, minutes: 60, seconds: 1 };
        const result = { days: 0, hours: 0, minutes: 0, seconds: 0 };
        for (const unit of ['days', 'hours', 'minutes', 'seconds']) {
          if (!this.visibleUnits.includes(unit)) continue;
          const divisor = divisors[unit];
          result[unit] = Math.floor(total / divisor);
          total %= divisor;
        }

        return result;
      }

      format(value) {
        if (!this.leadingZeros) return String(value);
        return String(value).padStart(2, '0');
      }

      render(ms) {
        const parts = this.splitUnits(ms);
        this.el.querySelectorAll('[data-unit]').forEach((node) => {
          const unit = node.dataset.unit;
          node.textContent = this.format(parts[unit] || 0);
        });
      }

      tick() {
        if (this.destroyed) return;
        this.timeoutId = null;
        const now = Date.now();
        const remaining = this.getRemaining(now);
        this.render(remaining);

        if (remaining <= 0 && !this.shouldRepeat()) return;

        const nextDelay = now < this.boundaryUntil ? 100 : Math.max(80, Math.min(250, 1000 - (now % 1000) + 20));
        this.timeoutId = setTimeout(() => this.tick(), nextDelay);
      }
    }

    class ElvyneAnnouncement {
      constructor(root) {
        this.root = root;
        this.timers = [];
      }

      init() {
        this.destroy();
        this.timers = Array.from(this.root.querySelectorAll(TIMER_SELECTOR)).map((el) => {
          const timer = new ElvyneTimer(el);
          timer.init();
          return timer;
        });
      }

      destroy() {
        this.timers.forEach((timer) => timer.destroy());
        this.timers = [];
      }
    }

    const manager = window.ElvyneAnnouncementCountdown || {
      instances: new Map(),
      listenersBound: false,
      initRoot(root) {
        if (!root || !root.matches(ROOT_SELECTOR)) return;
        const key = root.dataset.sectionId || root.id;
        this.destroyKey(key);
        const instance = new ElvyneAnnouncement(root);
        instance.init();
        this.instances.set(key, instance);
      },
      destroyKey(key) {
        const existing = this.instances.get(key);
        if (existing) existing.destroy();
        this.instances.delete(key);
      },
      initWithin(scope = document) {
        if (scope.matches && scope.matches(ROOT_SELECTOR)) this.initRoot(scope);
        if (scope.querySelectorAll) scope.querySelectorAll(ROOT_SELECTOR).forEach((root) => this.initRoot(root));
      },
      ensureWithin(scope = document) {
        const roots = [];
        if (scope.matches && scope.matches(ROOT_SELECTOR)) roots.push(scope);
        if (scope.querySelectorAll) roots.push(...scope.querySelectorAll(ROOT_SELECTOR));
        roots.forEach((root) => {
          const key = root.dataset.sectionId || root.id;
          if (!this.instances.has(key)) this.initRoot(root);
        });
      },
      bind() {
        if (this.listenersBound) return;
        this.listenersBound = true;
        document.addEventListener('shopify:section:load', (event) => this.initWithin(event.target));
        document.addEventListener('shopify:section:unload', (event) => {
          const detailId = event.detail && event.detail.sectionId;
          if (detailId) this.destroyKey(String(detailId));
          const target = event.target;
          const root = target && target.matches && target.matches(ROOT_SELECTOR) ? target : target && target.querySelector ? target.querySelector(ROOT_SELECTOR) : null;
          if (root) this.destroyKey(root.dataset.sectionId || root.id);
        });
        document.addEventListener('shopify:section:select', (event) => this.ensureWithin(event.target));
      }
    };

    window.ElvyneAnnouncementCountdown = manager;
    manager.bind();

    const boot = () => manager.initWithin(document);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot, { once: true });
    } else {
      boot();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
